import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { EntitlementGate } from '@/components/gates';
import { ComposeFlow } from '@/components/scout';

export const Route = createFileRoute('/scout/compose')({
  component: () => (
    <EntitlementGate module="scout">
      <div className="space-y-6">
        <PageHeader title="Criteria Composer" />
        <ComposeFlow />
      </div>
    </EntitlementGate>
  ),
});
